import { AssetItem, RecommendedAsset } from 'config/api/actionLibrary/actionLibrary.types';

/**
 * Maps RecommendedAsset from API to AssetItem for form usage
 */
export const mapRecommendedAssetToItem = (asset: RecommendedAsset): AssetItem => ({
  id: asset.id,
  name: asset.name,
  key: asset.name, // RecommendedAsset doesn't have key, use name as fallback
  category: {
    id: asset.category.id,
    name: asset.category.name,
  },
  owner: {
    id: asset.owner.id,
    email: asset.owner.email,
    fullName: `${asset.owner.profile.firstName} ${asset.owner.profile.lastName}`.trim(),
  },
});

/**
 * Maps AssetItem from available assets to form AssetItem
 */
export const mapAvailableAssetToItem = (asset: AssetItem): AssetItem => ({
  id: asset.id,
  name: asset.name,
  key: asset.key,
  category: asset.category
    ? {
        id: asset.category.id,
        name: asset.category.name,
      }
    : { id: 0, name: '' },
  owner: {
    id: asset.owner.id,
    email: asset.owner.email,
    fullName: asset.owner.fullName,
  },
});
